import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PackageVersionDTO } from '../model/package-version-dto';
import { BaseService } from './base-service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class UpdatesService extends BaseService {
  private readonly httpClient: HttpClient | undefined;
  constructor(http: HttpClient, router: Router) {
    super(http, router);
    this.httpClient = http;
  }

  getUpdatesFrontend(): Observable<any> {
    return this.httpClient!.get('/assets/npm-outdated.json');
  }

  public getUpdatesBackend(): Promise<PackageVersionDTO[]> {
    const request = this.get<PackageVersionDTO[]>(
      `updates/backend?=pageNumber=1&pageSize=9999`
    );
    return this.apiCall<PackageVersionDTO[]>(request);
  }
}
